































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list/index'
import CustomForm from '@/components/custom-form/index.vue'
import appconst from '@/lib/appconst'
@Component({
  components: {
    CustomForm,
  },
})
export default class GoodsSelect extends Vue {
  // 选择的商品Id
  @Prop({
    type: Array,
    default: () => {
      return []
    },
  })
  selectedItems!: string[]

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean
  // 是否显示导入按钮
  @Prop({
    type: Boolean,
    default: false,
  })
  isShow?: boolean
  // 按钮文字
  @Prop({
    type: String,
    default: '选择商品',
  })
  btnText!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Prop({
    type: Boolean,
    default: true,
  })
  IsMultiple!: boolean

  // 默认查上架商品 true 上架 false 下架 null 全部
  @Prop({
    type: Boolean,
    default: true,
  })
  IsPublished!: boolean

  @Prop({
    type: String,
    default: '',
  })
  Source!: string

  @Prop({
    type: String,
    default: 'promotion',
  })
  ImportType!: string

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  uploadUrl = ''
  templateUrl = ''
  // uploadData = {}
  // requestHeader = {}
  uploadFile = ''
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '商品名称/商品货号',
      },
      key: 'keyWord',
    },
    {
      label: '商品分类：',
      type: 'select',
      key: 'categoryId',
      props: {
        placeholder: '请选择',
      },
      options: [],
    },
  ]
  get columns() {
    var data: any[] = [
      {
        title: '商品图',
        slot: 'pictureUrl',
        align: 'center',
      },
      {
        title: '商品名称',
        width: 350,
        key: 'name',
      },
      {
        title: '货号',
        key: 'code',
      },
      {
        title: '售价',
        key: 'price',
      },
      {
        title: '所属分类',
        slot: 'categories',
        align: 'center',
      },
      {
        title: '库存',
        key: 'totalStockQuantity',
      },
      {
        title: '状态',
        key: 'published',
        slot: 'published',
      },
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center',
      })
    }
    return data
  }
  async mounted() {
    if (this.ImportType === 'promotion') {
      const preSales = this.Source == 'preSales' ? 'True' : 'False'

      this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/PromotionActivity/TemplateFile`
      this.uploadUrl = this.$route.query.id
        ? `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/PromotionActivity/excel/upload?id=${
            this.$route.query.id
          }&preSales=${preSales}`
        : `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/PromotionActivity/excel/upload?preSales=${preSales}`
    } else if(this.ImportType === 'timeTask') {
      this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/ProductTimeTask/ImportTemplateFile`
      this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/ProductTimeTask/ImportFile`
    } else if(this.ImportType === 'related') {
      this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/relatedProduct/ImportFile`
      this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/relatedProduct/ImportTemplateFile`
    } else {
      this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/coupon/TemplateFile`
      this.uploadUrl = this.$route.query.id
        ? `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/coupon/excel/upload?id=${this.$route.query.id}`
        : `${appconst.remoteServiceBaseUrl}/api/MarketingManagement/coupon/excel/upload`
    }

    // this.uploadData = {
    //   id: this.$route.query.id
    // }
    // this.requestHeader = {
    //   "Content-Type": "application/json; charset=utf-8"
    // }
    this.getCategoriesAll()
  }
  @Watch('modal1')
  modalShowChange(show) {
    if (show) this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    if (valid) {
      this.loadGoodsList(form)
    }
  }

  async loadGoodsList(form?) {
    let keyWord = null
    let categoryId = null
    let vm = this
    if (form) {
      keyWord = form['keyWord']
      categoryId = form['categoryId']
    }
    await GoodsApi.getList(vm.pageSize, vm.pageIndex, keyWord, categoryId, vm.IsPublished).then((res) => {
      // console.log("goods", res);
      vm.total = res.data.totalCount
      let result = []
      res.data.items.forEach((element) => {
        element['_disabled'] = vm.selectedItems.findIndex((x) => x == element.id) > -1
        result.push(element)
      })
      vm.data = result
    })
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.filters.some((item) => {
          if (item.label == '商品分类：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.fullName,
              }
            })
            return true
          }
        })
      }
    })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow.id)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection(), 'selectGoods')
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.modal1 = false
  }

  uploadSuccess(res) {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    // this.loadData();
    console.log(res)
    if (this.ImportType === 'Coupon') {
      res = res.map((x) => {
        return {
          id: x.productId,
          pictureUrl: x.pictureUrl,
          name: x.productName,
          code: x.productCode,
          marketPrice: x.marketPrice,
          price: x.price,
        }
      })
    }
    this.$emit('on-change', res, 'uploadGoods')
  }

  downloadTemplate() {
    location.href = this.templateUrl
  }

  /**
   * 导入商品
   */
  // handleImportProducts() {}
  // handleUploadBefore(file) {
  //   console.log(file)
  //   this.readFile(file)
  // }
  // // 读取文件
  // readFile(file) {
  //   const reader = new FileReader()
  //   reader.readAsArrayBuffer(file)
  //   reader.onerror = (e) => {
  //     this.$Message.error('文件读取出错')
  //   }
  //   reader.onload = (e) => {
  //     this.$Message.info('文件读取成功')
  //     const data = e.target.result
  //     this.uploadFile = String.fromCharCode.apply(null, new Uint16Array(data))
  //     console.log(data, this.uploadFile);
  //   }
  // }
}
